{
  "dec-explorer": {
    "title": "<h2>Scopri i benefici del modello \nutilizzando DEC Explorer</h2>",
    "description": "Quantifica in 3 semplici passi i risultati che puoi ottenere adottando la soluzione di DEC Energy: <ul><li>Scegli un impianto tra quelli disponibili</li><li>Inserisci il target di produzione rinnovabile</li><li>Ottieni subito un'analisi quantitativa</li></ul>",
    "cta": "Utilizza DEC Explorer",
    "tag": "<Logo/> EXPLORER"
  },

  "redirect": {
    "head": {
      "tag": "LA SOLUZIONE DEC ENERGY",
      "title": "<h2>Scopri i vantaggi di adottare il nostro modello</h2>"
    },
    "left": {
      "title": "<h3>Rendi profittevole il tuo approvvigionamento di energia rinnovabile</h3>",
      "cta": "Per energy manager"
    },
    "right": {
      "title": "<h3>Contribuisci alla transizione energetica con un impatto reale e comunicabile</h3> ",
      "cta": "Per sustainability manager"
    }
  },
  "calendly": {
    "tag": "SCOPRI TUTTI I VANTAGGI",
    "title": "<h2>Scopri come rendere redditizio \nil tuo consumo di GO</h2>",
    "description": "Prenota una consulenza gratuita con i nostri esperti per ricevere un’analisi su misura\n su quanto puoi risparmiare con DEC (sui tuoi consumi elettrici)."
  }
}
